<template>

<div class="connections">

	<div class="connections-loading prp-loading" v-if="is.loading" />

	<com-user v-for="profile in candidates" :key="profile.id" :profile="profile" />

</div>

</template>

<script>

import comUser from './connections/User'

export default {

	components: {
		'com-user': comUser
	},

	data: function() {

		return {
			is: {
				loading: true
			},
			users: [],
			timer: false
		}

	},

	created: function() {

		this.update()

	},

	beforeDestroy: function() {

		clearTimeout(this.timer)
		
	},

	computed: {

		candidates: function() {

			return this.$_.filter(this.users, function(item) {

				return item.circuit === this.$store.getters['circuits/current'] || item.circuit === false

			}.bind(this))

		}

	},

	methods: {

		update: function() {

			clearTimeout(this.timer)

			this.$api.request('monitor/dashboard').then(function(json) {

				this.users = json.users

				this.timer = this.$_.delay(this.update.bind(this), 10000)

				this.is.loading = false

			}.bind(this))

		},

	}

}

</script>

<style scoped>

.connections {
	display: flex;
	flex-direction: column;
	min-height: 100%;
}

.connections-loading {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-left: -32px;
	margin-top: -32px;
}

</style>